import { Components } from 'formiojs'

import { resolveApiUrl } from './api-url.util'

const Select = Components.components.select

export class DirectorySelectComponent extends Select {
  static schema(...extend) {
    return Select.schema({
      type: 'directorySelect',
      label: 'Directory Select',
      key: 'directorySelect'
    })
  }

  static get builderInfo() {
    return {
      title: 'Verzeichnis Auswahl',
      icon: 'th-list',
      documentation: '/userguide/#select',
      weight: 0,
      schema: DirectorySelectComponent.schema()
    }
  }

  constructor(component, options, data) {
    super(component, options, data)
  }

  init() {
    super.init()
  }

  loadItems(url: string, ...args: unknown[]) {
    // @ts-expect-error loadItems exists on the Select base component
    return super.loadItems(resolveApiUrl(url), ...args)
  }

  render(content) {
    return super.render('<div ref="customRef">This is a custom component!</div>')
  }

  setItems(items: any[], fromSearch) {
    if (items && items.length > 0) {
      items.sort((a, b) => {
        const labelA = String((this as any).itemTemplate(a))
          .replace(/(<([^>]+)>)/gi, '')
          .trim()
        const labelB = String((this as any).itemTemplate(b))
          .replace(/(<([^>]+)>)/gi, '')
          .trim()

        return labelA.localeCompare(labelB)
      })
    }

    const options = (this.selectOptions as unknown as any[]) || []

    if (items?.length !== this.selectOptions?.length) {
      const missingItem = options.find((item) => !items.find((i) => i.id === item.value.id))?.value

      if (missingItem) {
        items.unshift(missingItem)
      }
    }

    // @ts-expect-error making sure setItems exists
    if (!super.setItems) {
      return
    }

    // @ts-expect-error we know this is a Select component
    return super.setItems(items, fromSearch)
  }

  attach(element) {
    return super.attach(element)
  }

  detach() {
    return super.detach()
  }

  destroy() {
    return super.destroy()
  }

  normalizeValue(value, flags = {}) {
    return super.normalizeValue(value)
  }

  getValue() {
    return super.getValue()
  }

  getValueAt(index) {
    return super.getValueAt(index)
  }

  setValue(value, flags = {}) {
    return super.setValue(value, flags)
  }

  setValueAt(index, value, flags = {}) {
    return super.setValueAt(index, value, flags)
  }
}
